import { useEffect, useState } from "react";
import showNotification from "../../components/notification/showNotification";
import { AddStory } from "../../action/banner";
import {
  fetchDistricts,
  fetchGaons,
  fetchStates,
  fetchSubDistricts,
} from "../../action/location";
import { useFormik } from "formik";
import Select from "react-select";
import uploadImage from "../../action/imageUpload";
import ThumbnailPicker from "../../components/ThumbnailPicker/ThumbnailPicker";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { Loader } from "../../components/loader";
const CreateStory = () => {
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [gaonList, setGaonList] = useState([]);
  const [stateId, setStateId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [blockId, setBlockId] = useState("");
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [videoPreview, setVideoPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState(0);

  const navigate = useNavigate();
  const addFormik = useFormik({
    initialValues: {
      title: "",
      isPublic: true,
      assets: {
        type: "",
        url: "",
        w: 200,
        h: 200,
      },
    },
    onSubmit: async (values) => {
      const response = await AddStory(values);
      if (response?.status) {
        setIsOpenModal(false);
        showNotification("Success", response.data?.message, "success");
        addFormik.resetForm();
        navigate("/admin/story-list");
      } else {
        showNotification("Error", "Please add story content", "danger");
      }
      addFormik.resetForm();
    },
  });
  const uploadMediaImage = async (file, type) => {
    if (file.type.startsWith("image/")) {
      const formData = new FormData();
      formData.append("file", file);
      const res = await uploadImage(formData, "gaon");
      if (res.status) {
        if (type == 1) {
          showNotification(
            "success",
            "Image uploaded successfully!",
            "success"
          );
          addFormik.setFieldValue("assets.url", res.data[0]);
        } else {
          if (isOpenModal) {
            addFormik.setFieldValue("assets.url", res.data[0]);
          }
        }
      }
    } else {
      showNotification("Error", "Please upload only image", "danger");
    }
  };
  // const handleVideoUpload = async (e) => {
  //     const file = e.target.files[0];
  //     if (file) {
  //         // Create a video element to generate a thumbnail
  //         const videoElement = document.createElement("video");
  //         videoElement.src = URL.createObjectURL(file);
  //         videoElement.currentTime = 1; // Set time at which to capture the thumbnail (e.g., 1 second)

  //         videoElement.onloadeddata = () => {
  //             const canvas = document.createElement("canvas");
  //             canvas.width = videoElement.videoWidth;
  //             canvas.height = videoElement.videoHeight;
  //             const ctx = canvas.getContext("2d");
  //             ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

  //             const thumbnail = canvas.toDataURL("image/png");
  //             setVideoPreview(thumbnail); // Set the thumbnail as preview
  //         };

  //         const formData = new FormData();
  //         formData.append("file", file);

  //         try {
  //             const res = await uploadImage(formData, "module");
  //             if (res.status) {
  //                 addFormik.setFieldValue(`assets.url`, res.data[0]);
  //             }
  //         } catch (error) {
  //             console.error("Error uploading video:", error);
  //         }
  //     }
  // };
  const handleVideoUpload = async (e) => {
    setLoading(true);
    const file = e.target.files[0];
    if (!file) return;
    const maxSize = 8 * 1024 * 1024; // 25MB in bytes

    if (file.size > maxSize) {
      showNotification(
        "Error",
        "The file size must be less than 8MB.",
        "danger"
      );
      setLoading(false);
      return;
    } else {
      // Create a video element to generate a thumbnail
      const videoElement = document.createElement("video");
      videoElement.src = URL.createObjectURL(file);
      videoElement.currentTime = 1; // Capture the thumbnail at 1 second

      videoElement.onloadeddata = () => {
        const canvas = document.createElement("canvas");
        canvas.width = videoElement.videoWidth;
        canvas.height = videoElement.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
        const thumbnail = canvas.toDataURL("image/png");
        setVideoPreview(thumbnail); // Set the thumbnail as preview
      };

      const formData = new FormData();
      formData.append("file", file);

      try {
        const res = await uploadImage(formData, "module");
        if (res.status) {
          addFormik.setFieldValue(`assets.url`, res.data[0]);
        } else {
          console.log("Upload error");
        }
      } catch (error) {
        console.log("Error uploading video:", error);
      } finally {
        setLoading(false);
      }
    }
  };
  const getState = async () => {
    const res = await fetchStates();
    if (res.status) {
      const arr = res?.data?.map((item) => {
        return { value: item._id, label: item.name };
      });
      setStates(arr);
    }
  };
  const getDistrict = async () => {
    const res = await fetchDistricts(stateId);
    if (res.status) {
      const arr = res?.data?.map((item) => {
        return { value: item._id, label: item.name };
      });
      setDistricts(arr);
    }
  };
  const getSubDistrict = async () => {
    const res = await fetchSubDistricts(districtId);
    if (res.status) {
      const arr = res?.data?.map((item) => {
        return { value: item._id, label: item.name };
      });
      setBlocks(arr);
    }
  };
  const fetchGaonList = async () => {
    const response = await fetchGaons(blockId);
    if (response.status) {
      const arr = response?.data.map((item) => {
        return { value: item._id, label: item.name };
      });
      setGaonList(arr);
    }
  };

  useEffect(() => {
    getState();
  }, [addFormik.values.type]);
  useEffect(() => {
    getDistrict();
  }, [stateId]);
  useEffect(() => {
    getSubDistrict();
  }, [districtId]);
  useEffect(() => {
    fetchGaonList();
  }, [blockId]);
  useEffect(() => {
    addFormik.setFieldValue("assets.url", "");
  }, [addFormik.values.assets.type]);

  return (
    <div className="payout_data-content">
      <div className="payout_data-head">
        <div className="payout_data-head-top mb-2">
          <div className="payout_data-left">
            <div className="payout_data_ttl">
              {" "}
              <Breadcrumb
                paths={[
                  {
                    name: "Story",
                    link: `/admin/story-list`,
                  },
                  { name: "Create story", link: "/create-admin-story" },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="add_buyer_content">
        <form onSubmit={addFormik.handleSubmit}>
          <div className="row">
            <div className="col-lg-6">
              <div className="input-box">
                <div className="input-label">Type</div>
                <div className="input_field">
                  <select
                    className="input"
                    required
                    name="type"
                    placeholder="Enter Title"
                    value={addFormik.values.assets.type}
                    onChange={(e) =>
                      addFormik.setFieldValue("assets.type", e.target.value)
                    }>
                    <option value="">Please Select Type...</option>
                    <option value="2">IMAGE</option>
                    <option value="1">VIDEO</option>
                    <option value="0">TEXT</option>
                  </select>
                </div>
              </div>
            </div>
            {(addFormik.values.assets.type == 1 ||
              addFormik.values.assets.type == 2) && (
              <div className="col-lg-6">
                <div className="input-box">
                  <div className="input-label">Caption</div>
                  <div className="input_field">
                    <input
                      className="input"
                      name="title"
                      placeholder="Enter Title"
                      value={addFormik.values.title}
                      onChange={addFormik.handleChange}
                    />
                  </div>
                </div>
              </div>
            )}

            {addFormik.values.assets.type == 0 ? (
              <div className="col-lg-6">
                <div className="input-box">
                  <div className="input-label">Caption</div>
                  <div className="input_field">
                    <input
                      className="input"
                      required
                      name="title"
                      placeholder="Enter Title"
                      value={addFormik.values.assets.url}
                      onChange={(e) =>
                        addFormik.setFieldValue("assets.url", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
            ) : addFormik.values.assets.type == 2 ? (
              <div className="col-lg-6">
                <div
                  className="option-card"
                  style={{ display: "flex", marginTop: "36px" }}>
                  <ThumbnailPicker
                    width="auto"
                    height="250px"
                    onFileSelect={(file) => {
                      const _URL = window.URL || window.webkitURL;

                      const img = new Image();
                      uploadMediaImage(file, 1);

                      img.src = _URL.createObjectURL(file);
                    }}
                    image={addFormik.values.assets.url}
                    required
                  />
                </div>
              </div>
            ) : (
              addFormik.values.assets.type == 1 && (
                <div className="col-lg-6">
                  <div className="input-box">
                    <div className="input-label">Select video</div>
                    <input
                      type="file"
                      accept="video/*"
                      onChange={handleVideoUpload}
                    />

                    {loading ? (
                      <Loader />
                    ) : (
                      videoPreview && (
                        <div className="mt-3">
                          <img
                            src={videoPreview}
                            alt="Video Thumbnail"
                            style={{ width: "200px", height: "auto" }}
                          />
                        </div>
                      )
                    )}
                  </div>
                </div>
              )
            )}
            <div className="row">
              <div className="col-lg-6">
                <div className="d-flex w-full gap-5 mt-5 story_label_box">
                  <div className="input-label">Is Public</div>
                  <div className="d-flex gap-4 ">
                    <label>
                      <input
                        type="radio"
                        name="isPublic"
                        className="mx-2"
                        value="true"
                        checked={addFormik.values.isPublic === true}
                        onChange={() =>
                          addFormik.setFieldValue("isPublic", true)
                        }
                      />
                      Yes
                    </label>

                    <label>
                      <input
                        type="radio"
                        name="isPublic"
                        className="mx-2"
                        value="false"
                        checked={addFormik.values.isPublic === false}
                        onChange={() =>
                          addFormik.setFieldValue("isPublic", false)
                        }
                      />
                      No
                    </label>

                    {/* <div className="toggle-switch ms-4 contest_toggle">
                                            <input
                                                type="checkbox"
                                                id="toggle_public" className="toggle-checkbox"
                                                checked={addFormik.isPublic}
                                                onChange={() =>
                                                    addFormik.setFieldValue("isPublic", !addFormik.values.isPublic)
                                                }

                                            />
                                            <label
                                                for="toggle_public"
                                                className="toggle-label"
                                            ></label>
                                        </div> */}
                  </div>
                </div>
              </div>
            </div>
            {addFormik.values.isPublic === false && (
              <>
                <div className="col-lg-6">
                  <div className="input-box">
                    <div className="input-label">
                      State
                      <span>*</span>
                    </div>
                    <Select
                      name="stateId"
                      options={states}
                      onChange={(selectedOptions) => {
                        const id = Array.isArray(selectedOptions)
                          ? selectedOptions.map((option) => option.value)
                          : selectedOptions
                          ? [selectedOptions.value]
                          : [];
                        setStateId(id);
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="input-box">
                    <div className="input-label">
                      District
                      <span>*</span>
                    </div>
                    <Select
                      name="districtId"
                      options={districts}
                      onChange={(selectedOptions) => {
                        const id = Array.isArray(selectedOptions)
                          ? selectedOptions.map((option) => option.value)
                          : selectedOptions
                          ? [selectedOptions.value]
                          : [];

                        setDistrictId(id);
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="input-box">
                    <div className="input-label">
                      Sub District
                      <span>*</span>
                    </div>
                    <Select
                      name="blockId"
                      options={blocks}
                      onChange={(selectedOptions) => {
                        const id = Array.isArray(selectedOptions)
                          ? selectedOptions.map((option) => option.value)
                          : selectedOptions
                          ? [selectedOptions.value]
                          : [];
                        setBlockId(id);
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="input-box">
                    <div className="input-label">
                      Gaon
                      <span>*</span>
                    </div>
                    <Select
                      name="gaonId"
                      options={gaonList}
                      onChange={(selectedOptions) => {
                        const id = Array.isArray(selectedOptions)
                          ? selectedOptions.map((option) => option.value)
                          : selectedOptions
                          ? [selectedOptions.value]
                          : [];
                        addFormik.setFieldValue("gaonId", id[0]);
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      readOnly
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="mt-3 flex_btn">
            <Link
              className="btn"
              style={{ color: "white", backgroundColor: "red" }}
              color="red"
              to={"/admin/story-list"}>
              <i className="fas fa-arrow-left"></i>
              &nbsp;&nbsp; Back
            </Link>
            <button
              className="btn btn-success"
              type="submit">
              Create
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default CreateStory;
